// SimpleExperience now delegates to the full timeline Experience component.
import Experience from './Experience';
export default Experience;
